// extracted by mini-css-extract-plugin
export default {"rightColumn__container":"RightColumn_rightColumn__container__T9dVM","body":"RightColumn_body__wfNLF"};